import i18n from '../../i18n';

export const buildFaqSchema = () => {
  let items;
  try {
    items = i18n.t('landing.faq.items', { returnObjects: true });
  } catch (e) {
    return null;
  }
  if (!Array.isArray(items) || items.length === 0) return null;
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": items.map(({ question, answer }) => ({
      "@type": "Question",
      "name": question,
      "acceptedAnswer": { "@type": "Answer", "text": answer }
    }))
  };
};
